import { Col, Row } from "react-bootstrap";

const BrandStepTimeLine = ({ activeStep }) => {
    const themeColor = '#165b5b';
    const styles = {
        container:{
            width:'50%',
            margin:'auto'
        },
        timelineContainer: {
            position: 'relative',
            // padding: '40px 0',
            margin: '30px 0'
        },
        timeline: {
            position: 'relative',
            height: '4px',
            backgroundColor: '#e0e0e0',
            borderRadius: '2px',
            margin: '20px 0'
        },
        progress: {
            position: 'absolute',
            height: '100%',
            backgroundColor: themeColor,
            borderRadius: '2px',
            transition: 'width 0.4s ease',
            width: activeStep === 1? '0%' : activeStep === 2? '50%':'100%'
        },
        step: {
            position: 'absolute',
            top: '-9px',
            transform: 'translateX(-33%)',
            textAlign: 'center'
        },
        stepIndicator: {
            width: '20px',
            height: '20px',
            fontSize:'12px',
            borderRadius: '50%',
            backgroundColor: themeColor,
            border: '3px solid',
            borderColor: '#e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 10px',
            fontWeight: 'bold',
            color: 'white',
            transition: 'all 0.3s ease'
        },
        activeStep: {
            borderColor: themeColor,
            color: 'white',
            boxShadow: `0 0 0 8px ${themeColor}20`
        },
        completedStep: {
            borderColor: themeColor,
            backgroundColor: themeColor,
            color: '#fff'
        },
        stepLabel: {
            position: 'absolute',
            top: '23px',
            left: '50%',
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            fontSize: '14px',
            fontWeight: '600',
            color: '#333'
        },
        activeLabel: {
            color: themeColor
        }
    }
    return (
        <div style={styles.container}>
            <Row>
                <Col>
                    <div style={styles.timelineContainer}>
                        <div style={styles.timeline}>
                            <div style={styles.progress}></div>

                            {/* Step 1 - Brand Details */}
                            <div style={{ ...styles.step, left: '0%' }}>
                                <div
                                    style={{
                                        ...styles.stepIndicator,
                                        ...(activeStep >= 1 ? styles.completedStep : {}),
                                        ...(activeStep === 1 ? styles.activeStep : {})
                                    }}
                                >
                                    {activeStep > 1 ? '✓' : '1'}
                                </div>
                                <div
                                    style={{
                                        ...styles.stepLabel,
                                        ...(activeStep === 1 ? styles.activeLabel : {})
                                    }}
                                >
                                    Brand Details
                                </div>
                            </div>

                            {/* Step 2 - Subscription */}
                            <div style={{ ...styles.step, left: '50%' }}>
                                <div
                                    style={{
                                        ...styles.stepIndicator,
                                        ...(activeStep === 2 ? styles.activeStep : {}),
                                        ...(activeStep > 1 ? styles.completedStep : {backgroundColor:'lightgray'})
                                    }}
                                >
                                    {activeStep > 2 ? '✓' : '2'}
                                </div>
                                <div
                                    style={{
                                        ...styles.stepLabel,
                                        ...(activeStep > 1 ? styles.activeLabel : {})
                                    }}
                                >
                                    Subscription
                                </div>
                            </div>

                              {/* Step 3 - Success */}
                              <div style={{ ...styles.step, left: '100%' }}>
                                <div
                                    style={{
                                        ...styles.stepIndicator,
                                        ...(activeStep === 4 ? styles.activeStep : {}),
                                        ...(activeStep > 2 ? styles.completedStep : {backgroundColor:'lightgray'})
                                    }}
                                >
                                     {activeStep > 3 ? '✓' : '3'}
                                </div>
                                <div
                                    style={{
                                        ...styles.stepLabel,
                                        ...(activeStep > 2 ? styles.activeLabel : {})
                                    }}
                                >
                                    Success
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};
export default BrandStepTimeLine;